import i18n from "@service/locale/i18";
import { required } from "vuelidate/lib/validators";
import { SessionEditFormSelectSourses } from "./types";

/**
 * Return object with form fields with vuelidate validation settings
 * @param langList
 * @returns
 */
export const getValidationObject = (langList: string[]) => {

    const langFields: { [key: string]: any } = {};

    langList.forEach((lang) => {
        langFields[`title.${lang}`] = {
            required
        }

        langFields[`description.${lang}`] = {}

        langFields[`type.${lang}`] = {}
    })

    return {
        session: {
            ...langFields,
            beginAt: {
                required
            },
            endAt: {
                required
            }
        }
    }
}

export const getSelectSourcesQuery = (sessionId: string) => {
    const fields = ["id", "title"];
    return {
        where: {
            id: sessionId,
        },
        include: [
            'title', 'description', { "groupIds": fields }, { "partnerId": fields }, { "tagsIds": fields }
        ]
    }
}

export const getSessionFormSelectSources = (): SessionEditFormSelectSourses => {
    return {
        groups: [],
        tags: [],
        partner: []
    }
}

export const getTypesList = () => {
    return [
        // {
        //     id: "webConference",
        //     title: i18n.t("agenda.broadcastType.webConference").toString()
        // },
        {
            id: "agora",
            title: i18n.t("agenda.broadcastType.agora").toString()
        },
        {
            id: "liveKit",
            title: i18n.t("agenda.broadcastType.liveKit").toString()
        },
        {
            id: "youTube",
            title: i18n.t("agenda.broadcastType.youTube").toString()
        },
        {
            id: "custom",
            title: i18n.t("agenda.broadcastType.custom").toString()
        },
        {
            id: "youTubeRecord",
            title: i18n.t("agenda.broadcastType.youTubeRecord").toString()
        },
        {
            id: "pastSessionRecord",
            title: i18n.t("agenda.broadcastType.pastSessionRecord").toString()
        }
    ]
}
